import { request } from '@/utils/request';

export function getHomePage() {
  return request({
    url: '/cdh/data/wheel/homePage',
    method: 'get',
  });
}
export function getHomePageDetail(data: any) {
  return request({
    url: '/cdh/data/wheel/homePage/detail',
    method: 'get',
    params: data,
  });
}

export function getWheelList(path: string) {
  return request({
    url: `/cdh/data/wheel/listAll${path}`,
    method: 'get',
  });
}

export function addWheelList(data: any) {
  return request({
    url: '/cdh/data/wheel/add',
    method: 'post',
    data,
  });
}

export function editWheelList(data: any) {
  return request({
    url: '/cdh/data/wheel/edit',
    method: 'POST',
    data,
  });
}

export function deletWheelList() {
  return request({
    url: '/cdh/data/wheel/edit',
    method: 'POST',
  });
}

export function datawheelgenerate(data: any) {
  return request({
    url: '/cdh/data/wheel/snapshot/generate',
    method: 'POST',
    data,
  });
}
export function getSnapshotHistory(data: any) {
  return request({
    url: `/cdh/data/wheel/snapshot/history/${data}`,
    method: 'get',
  });
}

export function postEditWheelDmgf(data: any) {
  return request({
    url: '/cdh/data/wheel/dmgf/edit',
    method: 'post',
    data,
  });
}
export function postfuzzyUser(data: any) {
  return request({
    url: 'user/list/fuzzy',
    method: 'post',
    data,
  });
}

export function postWheelDmgfList(data: any) {
  return request({
    url: '/cdh/data/wheel/dmgf/list',
    method: 'post',
    data,
  });
}

export function uploadDataWheel(data: any) {
  return request({
    url: '/cdh/data/wheel/dbo/upload',
    method: 'post',
    data,
  });
}
// cdh/data/wheel/snapshot/current/operation

export function getSnapshotCurrent(data: any) {
  return request({
    url: `cdh/data/wheel/snapshot/current/operation/${data}`,
    method: 'get',
  });
}
// /data/wheel/dbo/download/

export function getDownloadWheel(data: any) {
  return request({
    url: `/cdh/data/wheel/dbo/download//${data}`,
    method: 'get',
  });
}

export function sendmail(data: any) {
  return request({
    url: '/domain/sendMail',
    method: 'post',
    data,
  });
}

export function getWheelDetail(data: any) {
  return request({
    url: `/cdh/data/wheel/detail/${data}`,
    method: 'get',
  });
}

export function getkeyAccountOptions() {
  return request({
    url: '/cdh/data/wheel/keyAccount/options',
    method: 'get',
  });
}

export function postkeyAccountList(data: any) {
  return request({
    url: '/cdh/data/wheel/keyAccount/list',
    method: 'post',
    data,
  });
}

export function postkeyAccountEdit(data: any) {
  return request({
    url: '/cdh/data/wheel/keyAccount/edit',
    method: 'post',
    data,
  });
}
// /edm/cdh/data/wheel/release/fuzzyList

export function getDataWheelRealease(data: any) {
  const { path } = data;
  return request({
    url: `/cdh/data/wheel${path}/fuzzyList`,
    method: 'get',
    params: data,
  });
}
